<template>
    <div class="direction1">
        <div style="color: #BCBCBC; font-size: 40px;position: relative;top: 20px;">{{ TileName }}</div>
        <div class="line"></div>
        <!-- 标题块  -->
        <div class="nameBox">
            <div class="numBox">
                <el-image style="height: 25px; width: 25px; margin-top: 5px;"
                    src="../../static/image/iconss/Data.png"></el-image>
            </div>
            <div class="titleBox">
                <h3 style="position: relative;left: 23px;">数据科学与高质量数据集构建理论</h3>
            </div>
        </div>
        <!-- 内容块 -->
        <div>
            <div class="contentBox">
                <p>{{ researchContent }}</p>
                <p>{{ researchRoughContent }}</p>
            </div>

            <!-- 代表性结果块 -->
            <div class="Representative-Box">
                <div class="title-box3">
                    <el-image style="height: 20px; width: 20px; margin-top: 5px;"
                        src="../../static/image/icon.png"></el-image>
                    <h3 style="width: 300px; margin-top: 0px;">实验室代表性成果：</h3>
                </div>
                <!-- 基本信息 -->
                <ol>
                    <li v-for="item in representativeResults" :key="item.id">{{ item.value }}</li>
                </ol>
            </div>
            <!-- 图片块 -->
            <el-image class="imageBox" style="width: 100%;" src="../../static/image/Direction5.png"
                fit="cover" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            TileName: 'Research Direction',
            researchItems: [
                { id: 5, title: "数据科学与高质量数据集构建理论" }
            ],
            researchContent: "本团队开展的植保领域数据科学基础研究致力于解决农业多源异构数据的标准化采集与高通量存储难题，重点攻克多模态数据（光谱、图像、文本、时序及空间数据）的深度融合、清洗与质量控制技术。团队着力于植保数据采集标准与规范的联合制定，建立统一的采集口径与数据格式，构建涵盖实验室数据、田间监测数据及无人机采集数据的全维度资源库。通过研发高效的数据治理与安全合规审查体系，研究旨在打造具有广泛代表性和高精度的植物保护高质量数据集，实现从数据资源向数据资产的转化，为植保领域的数字化转型奠定坚实的底层数据基座。",
            researchRoughContent: "团队研究内容：植物保护数据集、数据标准制定、多模态数据采集、农业大数据治理、数据清洗与融合、光谱与图像数据、时序与空间数据、数据安全与合规、数据资产管理、高通量数据存储。",
            representativeResults: [
                // 暂无代表性成果，后续可补充
            ]
        };
    },
    mounted() {
        // 子页面加载时触发事件
        this.$emit('changeHeight1', '140%');
    },
};
</script>

<style scoped>
.imageBox {
    position: relative;
    top: 60px;
}

.contentBox {
    position: relative;
    top: 60px;
}

.contentBox p {
    font-weight: 500;
    text-align: left;
    text-indent: 2em;
    padding: 0px;
    margin: 0px;
    line-height: 30px;
}

.Representative-Box {
    position: relative;
    top: 60px;
    width: 95%;
}

.Representative-Box ol {
    list-style-type: decimal;
}

.Representative-Box ol li {
    line-height: 24px;
}

.nameBox {
    display: flex;
    position: relative;
    top: 49px;
}

.direction1 {
    width: 90%;
}

.line {
    position: relative;
    top: 30px;
    bottom: 32.5px;
    border: 0.1px solid #BCBCBC;
    width: 100%;
}

.numBox {
    width: 67px;
    height: 67px;
    background-color: #D4DFEB;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
}

.titleBox {
    height: 67px;
    width: 100%;
    font-size: 17px;
    color: #2E5A2D;
    background-color: #F7F9FA;
    justify-content: center;
    align-items: center;
}

.title-box3 {
    display: flex;
    width: 100%;
    margin-bottom: -30px;
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Direction5.vue